module.exports = __webpack_public_path__ + "img/20260309_5.ad05e08f.jpg";